import React from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { Checkbox } from '@tecuity/granite-ui/Checkbox'
import { TextInput } from '@tecuity/granite-ui/TextInput'
import { UPDATE_DETAIL_OUTPUT, UPDATE_HISTORY_DETAIL_OUTPUT } from '../SettingsReducer'

const AttributeDrawer = () => {
  const dispatch = useDispatch()
  const {
    selectedDetailOutput: { info = {}, accessor, isHistory },
  } = useSelector((state) => state.settings.recordDetailConfig, shallowEqual)
  return (
    <div className="attribute-drawer">
      <TextInput
        label={'Label'}
        value={info.DisplayName || ''}
        onChange={(e) => {
          const val = e.target.value
          dispatch({
            type: isHistory ? UPDATE_HISTORY_DETAIL_OUTPUT : UPDATE_DETAIL_OUTPUT,
            accessor,
            info: { ...info, DisplayName: val },
          })
        }}
        disabled={!accessor}
      />
      <Checkbox
        label={'Is Enabled'}
        checked={info.Enabled || false}
        onChange={(val) => {
          dispatch({
            type: isHistory ? UPDATE_HISTORY_DETAIL_OUTPUT : UPDATE_DETAIL_OUTPUT,
            accessor,
            info: { ...info, Enabled: val },
          })
        }}
        disabled={!accessor}
      />
    </div>
  )
}

export const GenericAttributeDrawer = (props) => {
  const dispatch = useDispatch()
  const {
    selectedDetailOutput: { info = {}, accessor, isHistory },
    subType,
  } = useSelector((state) => state.settings.recordDetailConfig, shallowEqual)
  const { isStructureCodeStandard } = props
  // console.log(info)
  return (
    <div className="attribute-drawer">
      <TextInput
        label={'Label'}
        value={isHistory ? info.label || info.Label || '' : info.DisplayName || ''}
        onChange={(e) => {
          const val = e.target.value
          dispatch({
            type: isHistory ? UPDATE_HISTORY_DETAIL_OUTPUT : UPDATE_DETAIL_OUTPUT,
            subType,
            accessor,
            info: {
              ...info,
              DisplayName: isHistory ? undefined : val,
              label: isHistory && !isStructureCodeStandard ? val : undefined,
              Label: isHistory && isStructureCodeStandard ? val : undefined,
            },
          })
        }}
        disabled={!accessor}
      />
      <Checkbox
        label={'Is Enabled'}
        checked={
          isStructureCodeStandard
            ? info.IsEnabled || false
            : isHistory
            ? info.enabled || false
            : info.Enabled || false
        }
        onChange={(val) => {
          dispatch({
            type: isHistory ? UPDATE_HISTORY_DETAIL_OUTPUT : UPDATE_DETAIL_OUTPUT,
            subType,
            accessor,
            info: {
              ...info,
              Enabled: isHistory || isStructureCodeStandard ? undefined : val,
              enabled: isHistory && !isStructureCodeStandard ? val : undefined,
              IsEnabled: isStructureCodeStandard ? val : undefined,
            },
          })
        }}
        disabled={!accessor}
      />
      {isHistory ? null : (
        <TextInput
          label={'Card Number'}
          type="number"
          value={info.CardNumber}
          onChange={(e) => {
            const val = e.target.value
            dispatch({
              type: UPDATE_DETAIL_OUTPUT,
              subType,
              accessor,
              info: {
                ...info,
                CardNumber: val,
              },
            })
          }}
          disabled={true}
        />
      )}
      {isHistory ? null : (
        <TextInput
          label={'Column'}
          type="number"
          value={info.Column}
          onChange={(e) => {
            const val = e.target.value
            dispatch({
              type: UPDATE_DETAIL_OUTPUT,
              subType,
              accessor,
              info: {
                ...info,
                Column: val,
              },
            })
          }}
          disabled={true}
        />
      )}
    </div>
  )
}

export default AttributeDrawer
